import getMemberCountInfo, { MemberCountInfo } from 'owa-mail-tips/lib/utils/getMemberCountInfo';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import getRecipientsFromRecipientWells from 'owa-recipient-common/lib/utils/getRecipientsFromRecipientWells';
import { SharingTipRecipientInfo } from 'owa-sharing-data';

export function getSharingTipRecipientInfo(
    recipientWells: RecipientWellWithFindControlViewState[],
    fromAddress: string
): SharingTipRecipientInfo[] {
    const recipients = getRecipientsFromRecipientWells(recipientWells);
    let recipientsInfo: SharingTipRecipientInfo[] = [];
    recipients.forEach(recipient => {
        const persona: FindRecipientPersonaType = recipient.persona;
        const memberCountInfo: MemberCountInfo = getMemberCountInfo(
            fromAddress,
            persona.EmailAddress.EmailAddress
        );
        if (memberCountInfo !== null) {
            recipientsInfo.push({
                emailAddress: persona.EmailAddress.EmailAddress,
                totalMemberCount: memberCountInfo.TotalMemberCount,
                externalMemberCount: memberCountInfo.ExternalMemberCount,
                name: persona.EmailAddress.Name,
            });
        }
    });

    return recipientsInfo;
}
